import React from "react";
import { createRoot } from "react-dom/client";
import "@phosphor-icons/web/regular";
import "@phosphor-icons/web/fill";
import "@analytics/ui/nocturne.css";
import "@analytics/ui/app.css";
import { App } from "./App.js";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
